function homepage() {
	const mainHomepage = document.querySelector('main.homepage');
	if (!mainHomepage) return;

	const swiperHero = new Swiper('.swiper-hero', {
		slidesPerView: 1,
		spaceBetween: 0,
		autoplay: {
			delay: 7500,
		},
		loop: true,
		pagination: {
			el: '.swiper-pagination',
			type: 'bullets',
			clickable: true,
		},
	});

	const swiperNews = new Swiper('.swiper-news', {
		slidesPerView: 1.15,
		spaceBetween: 32,
		loop: false,
		navigation: {
			prevEl: '.swiper-button-prev',
			nextEl: '.swiper-button-next',
		},
		breakpoints: {
			768: {
				slidesPerView: 2.15,
			},
			1200: {
				slidesPerView: 3.15,
			}
		}
	});

	activateShuffleOnVisible(".fh-shuffle", ".homepage .membership");

	const swiperLogo = new Swiper('.swiper-logo', {
		slidesPerView: 'auto',
		spaceBetween: 80,
		freeMode: true,
		freeModeMomentum: false,
		speed: 15000,
		autoplay: {
			delay: 0,
			disableOnInteraction: false,
		},
		loop: true,
	});

	const swiperLogoReverse = new Swiper('.swiper-logo-reverse', {
		slidesPerView: 'auto',
		spaceBetween: 80,
		freeMode: true,
		freeModeMomentum: false,
		speed: 15000,
		autoplay: {
			delay: 0,
			disableOnInteraction: false,
			reverseDirection: true,
		},
		loop: true,
	});
}
